import { QueryClient, isCancelledError } from 'react-query';

/**
 * React Query v3 `CancelledError` does not extend `Error`. It only has `revert`
 * and `silent`, so Sentry reports it as an unhandled object rejection.
 */
export const isQueryCancelledError = (error: unknown): boolean => {
  if (isCancelledError(error)) {
    return true;
  }

  if (error == null || typeof error !== 'object' || Array.isArray(error) || error instanceof Error) {
    return false;
  }

  return Object.prototype.hasOwnProperty.call(error, 'revert') && Object.prototype.hasOwnProperty.call(error, 'silent');
};

/**
 * Wipe cached user data on logout without cancelling in-flight mutations.
 * `queryClient.clear()` calls `mutation.cancel()`, which rejects with
 * CancelledError and becomes an unhandled rejection when mutateAsync is used.
 */
export const clearQueryClientOnLogout = (client: QueryClient): void => {
  client.getQueryCache().clear();

  const mutationCache = client.getMutationCache();
  mutationCache.getAll().forEach(mutation => {
    if (mutation.state.status === 'loading') {
      return;
    }

    mutationCache.remove(mutation);
  });
};
